// @ts-nocheck
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CheckboxPresentationProps } from "@store/MobiusOverrides/Checkbox/Checkbox";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import { LinkProps } from "@store/MobiusOverrides/Link/Link";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import ArrowUpward from "@store/Library/Components/Toolkit/Icons/ArrowUpward";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { IconPresentationProps } from "@insite/mobius/Icon";
/* Store Custom Code - End */

export interface ResultCountProps {
    wrapper?: InjectableCss;
    bottomWrapper?: InjectableCss;
    countText?: TypographyPresentationProps;
    selectAll?: CheckboxPresentationProps;
    // Store Custom Code
    wrapperNoBorders?: InjectableCss;
    backToTopLink?: LinkProps;
}

/* Store Custom Code - Start */
const getLinkProps = (src: IconPresentationProps["src"]) => {
    return mergeProps<LinkProps>(linkGetActionLinkProps(src), {
        css: css`
            text-transform: uppercase;
        `,
    });
};
/* Store Custom Code - End */

const wrapperProps = (side: "top" | "bottom", borders: boolean = true /* Store Custom Code */): InjectableCss => ({
    css: css`
        ${({ theme }) => css`
            ${side === "top"
                ? spacingStyles(null, theme.design.typography.spacing.base)
                : spacingStyles(theme.design.typography.spacing.base, null)}
        `}

        display: flex;
        flex-flow: row wrap;
        align-items: flex-end;
        justify-content: space-between;
        row-gap: 0.2em;
        font-size: ${x => x.theme.design.typography.size.smaller};
        /* Store Custom Code - Start */
        ${side === "top" &&
        borders &&
        css`
            padding: ${pxToRem(15)} 0;
            border-top: 1px solid ${getColor("common.border")};
            border-bottom: 1px solid ${getColor("common.border")};
        `}
        /* Store Custom Code - End */

        &::before {
            content: "";
        }
    `,
});

export const resultCountProps: ResultCountProps = {
    wrapper: wrapperProps("top"),
    bottomWrapper: wrapperProps("bottom"),
    countText: {
        css: css`
            flex-grow: 1;
            white-space: nowrap;
            margin: 0 1em;

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        `,
    },
    selectAll: {
        sizeVariant: "small",
        css: css`
            ${x => x.theme.checkbox.defaultProps?.css as any}
            ${inlineSeparatorStyles({ spacing: pxToRem(23) })}
            cursor: pointer;

            @media print {
                display: none;
            }
        `,
    },
    // Store Custom Code
    wrapperNoBorders: wrapperProps("top", false),
    backToTopLink: getLinkProps(ArrowUpward),
};
